import axios from "axios";

// Live pixel test: the admin's Pixel check opens a page with ?pixel_check=<nonce> in a hidden frame.
// The page then only loads each pixel's script (no PageView, no Lead event) and reports back.
const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api`;
const KEYS = [["meta_pixel_id", "meta"], ["google_ads_id", "google_ads"], ["ga4_measurement_id", "ga4"], ["tiktok_pixel_id", "tiktok"]];
const SRC = {
  meta: () => "https://connect.facebook.net/en_US/fbevents.js",
  google_ads: (id) => `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`,
  ga4: (id) => `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`,
  tiktok: () => "https://analytics.tiktok.com/i18n/pixel/events.js",
};

export const pixelCheckNonce = () => new URLSearchParams(window.location.search).get("pixel_check");

function loads(src) {
  return new Promise((resolve) => {
    const s = document.createElement("script");
    const timer = setTimeout(() => resolve(false), 10000);
    s.async = true;
    s.src = src;
    s.onload = () => { clearTimeout(timer); resolve(true); };
    s.onerror = () => { clearTimeout(timer); resolve(false); };
    document.head.appendChild(s);
  });
}

async function extraPixels(surface, slug) {
  try {
    const { data } = await axios.get(`${API}/public/site-pixels`, { params: { surface, slug: slug || undefined } });
    return data.pixels || [];
  } catch {
    return [];
  }
}

export async function reportPixelCheck(nonce, surface, slug, bundles) {
  const items = [];
  bundles.filter(Boolean).forEach((cfg) => KEYS.forEach(([k, kind]) => { if (cfg[k]) items.push({ kind, id: cfg[k] }); }));
  (await extraPixels(surface, slug)).forEach((px) => items.push({ kind: px.kind, id: px.pixel_id || px.id, extra: true }));
  const seen = new Set();
  const unique = items.filter((it) => { const k = `${it.kind}:${it.id}`; if (seen.has(k)) return false; seen.add(k); return true; });
  const results = await Promise.all(unique.map(async (it) => ({ ...it, loaded: it.kind === "custom" ? null : await loads(SRC[it.kind](it.id)) })));
  window.parent.postMessage({ type: "lf-pixel-check", nonce, surface, results }, "*");
}
